import { render, staticRenderFns } from "./PoliceSchool.vue?vue&type=template&id=563cfdd4&scoped=true"
import script from "./PoliceSchool.vue?vue&type=script&lang=js"
export * from "./PoliceSchool.vue?vue&type=script&lang=js"
import style0 from "./PoliceSchool.vue?vue&type=style&index=0&id=563cfdd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563cfdd4",
  null
  
)

export default component.exports